<template>
  <b-container fluid>
    <b-row>
      <b-col>
        <NotificationContainer v-if="!!message" class="messages-container" :message = "message"/>
        <ErrorsContainer class="messages-container" :errors = "errors"/>
        <p><b>Copies answers from one assignment term to multiple other assignment terms.</b></p>
        <p class="danger">Important! It overwrites answers of target assignment terms.</p>
        <div>
          <b-form inline @submit.prevent="submitForm" v-promise-btn="{action: 'submit'}">
            <label class="sr-only" for="fromAssignmentTermId">From AssignmentTerm ID</label>
            <b-input class="mb-2 mr-sm-2 mb-sm-0" required
                     id="fromAssignmentTermId"
                     v-model="formData.fromAssignmentTermId"
                     placeholder="From AssignmentTerm ID"/>

            <label class="sr-only" for="toAssignmentTermIds">To AssignmentTerm IDs</label>
            <b-input id="toAssignmentTermIds" required
                     v-model="formData.toAssignmentTermIds"
                     placeholder="To AssignmentTerms IDs"/>

            <b-col md="auto">
              <b-button type="submit" variant="success"> Run </b-button>
            </b-col>
          </b-form>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import OptionIdsMaintenanceProvider from '@/services/OptionIdsMaintenanceProvider'
import NotificationContainer from '@/components/NotificationContainer'
import ErrorsContainer from '@/components/ErrorsContainer'

export default {
  name: 'MapExclusionCriteria',
  data () {
    return {
      formData: {
        fromAssignmentTermId: null,
        toAssignmentTermIds: null
      },
      message: '',
      errors: []
    }
  },
  components: {
    NotificationContainer,
    ErrorsContainer
  },
  methods: {
    submitForm () {
      this.errors = []
      return new Promise((resolve, reject) => {
        OptionIdsMaintenanceProvider.mapExclusionCriteria(this.formData)
          .then((resp) => {
            this.message = resp.body['message']
            resolve(resp)
          }, (resp) => {
            this.errors = resp.body.errors
            resolve(resp)
          })
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#fromAssignmentTermId {
  width: 210px;
}
#toAssignmentTermIds {
  width: 250px;
}
.messages-container {
  margin-bottom: 15px;
}
.danger {
  color: red;
}
</style>
